var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5SearchIcon = function SvgAv5SearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "regular",
    viewBox: "5 5 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "M15.75 20.5a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5ZM19.388 19.938 22.984 25",
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAv5SearchIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9InJlZ3VsYXIiIHZpZXdCb3g9IjUgNSAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIKICAgICAgICAgIGQ9Ik0xNS43NSAyMC41QzE5LjQ3NzkgMjAuNSAyMi41IDE3LjQ3NzkgMjIuNSAxMy43NUMyMi41IDEwLjAyMjEgMTkuNDc3OSA3IDE1Ljc1IDdDMTIuMDIyMSA3IDkgMTAuMDIyMSA5IDEzLjc1QzkgMTcuNDc3OSAxMi4wMjIxIDIwLjUgMTUuNzUgMjAuNVoiCiAgICAgICAgICBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTE5LjM4NzYgMTkuOTM3NUwyMi45ODM3IDI1IiBzdHJva2U9IiM5QjlBQzgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";